import React from 'react';
import { Stack, Typography } from '@mui/material';
import ModalWithLoader from '../../../Tools/ModalWithLoader/ModalWithLoader';

type BatchErrorModalProps = {
  open: boolean;
  /** Phrase déjà traduite disant quel lot a échoué. */
  message: string;
  /** Motif renvoyé par l'API, quand elle en donne un. */
  reason: string | null;
  onClose: () => void;
};

/**
 * Échec d'un lot — envoi en affectation, envoi aux techniciens, renvoi en qualification.
 *
 * Seule la phrase change d'un lot à l'autre : le reste — la modale, l'empilement du motif
 * sous le message, le statut `error` — est commun aux deux étapes de l'écran.
 */
export default function BatchErrorModal({ open, message, reason, onClose }: BatchErrorModalProps) {
  return (
    <ModalWithLoader
      openModal={open}
      status={open ? 'error' : null}
      customErrorMessage={
        <Stack spacing={1} alignItems="center">
          <Typography variant="body2" fontWeight={500}>
            {message}
          </Typography>
          {reason !== null && (
            <Typography variant="body2" color="text.secondary" textAlign="center">
              {reason}
            </Typography>
          )}
        </Stack>
      }
      onClose={onClose}
    />
  );
}
